export default [
    {
        path: '/',
        redirect: '/home',
        name: 'index',
    },
    {
        path: '/home',
        name: 'home',
        component: () => import('@/views/Home.vue'),
        meta: {
            layout: 'default',
        },
    },
    {
        path: '/search',
        name: 'search',
        component: () => import('@/views/search/search.vue'),
        meta: {
            layout: 'default',
        },
    },
    {
        path: '/company/',
        name: 'company-pages',
        component: () => import('@/views/company/companypages.vue'),
        meta: {
            layout: 'default',
        },
    },
    {
        path: '/company/:id',
        name: 'company-page',
        props: true,
        activeQuery: 'category',
        component: () => import('@/views/company/companypage.vue'),
        meta: {
            layout: 'default',
            activeQueryMeta: 'category',
        },
    },
    {
        path: '/news',
        name: 'news-list',
        component: () => import('@/views/news/newslist.vue'),
        meta: {
            layout: 'default',
        },
    },
    {
        path: '/news/:id',
        name: 'news',
        props: true,
        component: () => import('@/views/news/newsarticle.vue'),
        meta: {
            layout: 'default',
        },
    },
    {
        path: '/events',
        name: 'events',
        component: () => import('@/views/events/events.vue'),
        meta: {
            layout: 'default',
        },
    },
    {
        path: '/events/:id',
        name: 'event',
        props: true,
        component: () => import('@/views/events/event.vue'),
        meta: {
            layout: 'default',
        },
    },
    {
        path: '/resources',
        name: 'resources',
        component: () => import('@/views/resources/resources.vue'),
        meta: {
            layout: 'default',
        },
    },
    {
        path: '/chat',
        name: 'chat',
        component: () => import('@/views/chat/chat.vue'),
        meta: {
            layout: 'default',
        },
    },
    {
        path: '/feedback',
        name: 'feedback',
        component: () => import('@/views/feedback/feedback.vue'),
        meta: {
            layout: 'default',
        },
    },
    {
        path: '/feedback/:id',
        name: 'feedback-details',
        props: true,
        component: () => import('@/views/feedback/feedback_details.vue'),
        meta: {
            layout: 'default',
        },
    },
    {
        path: '/people',
        name: 'people',
        component: () => import('@/views/people/people.vue'),
        meta: {
            layout: 'default',
        },
    },
    {
        path: '/benefits',
        name: 'benefits',
        component: () => import('@/views/benefits/benefits.vue'),
        meta: {
            layout: 'default',
        },
    },
    {
        path: '/faq',
        name: 'faq',
        component: () => import('@/views/faq/faq.vue'),
        meta: {
            layout: 'default',
        },
    },
    {
        path: '/polls',
        name: 'polls-list',
        component: () => import('@/views/polls/pollslist.vue'),
        meta: {
            layout: 'default',
        },
    },
    {
        path: '/poll/:id',
        name: 'poll',
        props: true,
        component: () => import('@/views/polls/poll.vue'),
        meta: {
            layout: 'default',
        },
    },
    {
        path: '/surveys/:id',
        name: 'survey',
        props: true,
        component: () => import('@/views/surveys/survey.vue'),
        meta: {
            layout: 'default',
        },
    },
    {
        path: '/profile',
        name: 'profile',
        component: () => import('@/views/profile/profile.vue'),
        meta: {
            layout: 'default',
        },
    },
    {
        path: '/piiri-articles',
        name: 'piiri-articles',
        component: () => import('@/views/piiri-articles/piiriarticles.vue'),
        meta: {
            layout: 'default',
        },
    },
    {
        path: '/piiri-articles/:id',
        name: 'piiri-article',
        props: true,
        component: () => import('@/views/piiri-articles/piiriarticle.vue'),
        meta: {
            layout: 'default',
        },
    },
    {
        path: '/login',
        name: 'auth-login',
        component: () => import('@/views/Login.vue'),
        meta: {
            layout: 'blank',
        },
    },
    {
        path: '/logout',
        name: 'auth-logout',
        component: () => import('@/views/logout.vue'),
        meta: {
            layout: 'blank',
        },
    },
    {
        path: '/change-password',
        name: 'change-password',
        component: () => import('@/views/change-password/index.vue'),
        meta: {
            layout: 'default',
        },
    },
    {
        path: '*',
        redirect: 'error-404',
    },
];
